/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface LogInterviewRequest
 */
export interface LogInterviewRequest {
  /**
   *
   * @type {string}
   * @memberof LogInterviewRequest
   */
  applicationId: string;
  /**
   *
   * @type {string}
   * @memberof LogInterviewRequest
   */
  jamieMeetingId: string;
  /**
   *
   * @type {string}
   * @memberof LogInterviewRequest
   */
  notes?: string | null;
}

/**
 * Check if a given object implements the LogInterviewRequest interface.
 */
export function instanceOfLogInterviewRequest(
  value: object,
): value is LogInterviewRequest {
  if (!("applicationId" in value) || value["applicationId"] === undefined)
    return false;
  if (!("jamieMeetingId" in value) || value["jamieMeetingId"] === undefined)
    return false;
  return true;
}

export function LogInterviewRequestFromJSON(json: any): LogInterviewRequest {
  return LogInterviewRequestFromJSONTyped(json, false);
}

export function LogInterviewRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LogInterviewRequest {
  if (json == null) {
    return json;
  }
  return {
    applicationId: json["applicationId"],
    jamieMeetingId: json["jamieMeetingId"],
    notes: json["notes"] == null ? undefined : json["notes"],
  };
}

export function LogInterviewRequestToJSON(json: any): LogInterviewRequest {
  return LogInterviewRequestToJSONTyped(json, false);
}

export function LogInterviewRequestToJSONTyped(
  value?: LogInterviewRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    applicationId: value["applicationId"],
    jamieMeetingId: value["jamieMeetingId"],
    notes: value["notes"],
  };
}
